import { ReactNode, useId, useState } from "react";
import './input-base.css'
import './input-text.css'
import BaseInput, { InputValidity } from "./input-base.tsx";

export default function TextInput (props: {
	label?: string,
	value: string,
  placeholder?: string,
  step?: number,
  prefix?: string,
  postfix?: string,
  disabled?: boolean,
  type: "text" | "number", 
  min?: number,
  max?: number,
  hint?: string,
  infoButton?: ReactNode,
  onChange: (value: string | undefined) => void,
  onKeyDown?: (e: React.KeyboardEvent) => void,
  onClick?: (e: React.MouseEvent) => void,
  onMouseUp?: (e: React.MouseEvent) => void,
  onMouseDown?: (e: React.MouseEvent) => void,
  onBlur?: () => void,
  validate?: (value: string) => Promise<boolean>, 
  onValidate?: (valid: boolean) => void,
}){
  const [nonValidValue, setNonValidValue] = useState<undefined | string>(undefined);
  const id = useId();

  return <div className={"text-input input"}>
        {props.label != "" && <label className={"text-input__label input__label"} htmlFor={id}>{props.infoButton}<span>{props.label}</span></label>}
        {props.disabled && <span className={"text-input__input-placeholder input__input-placeholder"}>{props.value}</span>}
        {!props.disabled && 
        <BaseInput 
          valid={nonValidValue ? InputValidity.Invalid : InputValidity.Valid} 
          id={id} 
          type={props.type} 
          step={props.step} 
          value={nonValidValue ? nonValidValue : props.value} 
          placeholder={props.placeholder}
          postfix={props.postfix}
          prefix={props.prefix}
          hint={props.hint}
          onBlur={props.onBlur} 
          onClick={props.onClick}
          onMouseUp={props.onMouseUp}
          onMouseDown={props.onMouseDown}
          onKeyDown={props.onKeyDown}
          onChange={async (value : string)=>{
              if(props.validate !== undefined && !(await props.validate(value))){
                    setNonValidValue(value);
                    props.onChange(undefined);
                    if(props.onValidate){
                      props.onValidate(false);
                    }
                    return;
                }
                if(props.onValidate){
                  props.onValidate(true);
                }
                setNonValidValue(undefined);
                props.onChange(value);

            // if(props.type == "number"){
            //   const valid_number = Math.min(props.max || Number.POSITIVE_INFINITY, Math.max(props.min || 0, parseFloat(value))).toString();
            //   if(props.validate !== undefined && !(await props.validate(value))){
            //      setNonValidValue(valid_number);
            //     props.onChange(undefined);
            //     if(props.onValidate){
            //       props.onValidate(false);
            //     }
            //     return;
            //   }
            //   if(props.onValidate){
            //     props.onValidate(true);
            //   }
            //   setNonValidValue(undefined);
            //   props.onChange(valid_number);
              
            // }else{
            //   if(props.validate !== undefined && !(await props.validate(value))){
            //     setNonValidValue(value);
            //     props.onChange(undefined);
            //     if(props.onValidate){
            //       props.onValidate(false);
            //     }
            //     return;
            //   }
            //   if(props.onValidate){
            //     props.onValidate(true);
            //   }
            //   setNonValidValue(undefined);
            //   props.onChange(value);
            // }
          }}/>}
    </div>
}